interface WidgetCardProps {
    id: number | undefined
    name: string
    previewImage?: string
}

export const WidgetCard = ({ id, name, previewImage }: WidgetCardProps) => {
    return (
        <div className="flex flex-col gap-2 h-full">

            {/* Widget Card */}
            <div
                className="
            w-full
            h-full
            flex
            flex-col
            rounded-lg
            border border-slate-300 dark:border-slate-500
            bg-slate-100 dark:bg-slate-700
            p-3
            shadow
            hover:bg-slate-200 dark:hover:bg-slate-600
            hover:shadow-md
            transition
            cursor-pointer
        "
            >
                {/* Title BELOW image */}
                <div className="mb-2 text-center flex-shrink-0">
                    <span
                        className="
                    block
                    text-sm
                    font-semibold
                    text-slate-800 dark:text-slate-100
                    truncate
                "
                        title={name}
                    >
                        {name}
                    </span>
                </div>
                {/* Image */}
                <div className="w-full h-32 rounded-md overflow-hidden bg-slate-200 dark:bg-slate-600 flex items-center justify-center flex-shrink-0">
                    {previewImage ? (
                        <img
                            src={previewImage}
                            alt={name}
                            className="w-full h-full object-contain"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-slate-400 text-xs">
                            No preview available
                        </div>
                    )}
                </div>


            </div>

        </div>

    )
}
